import {useAuth} from "../../context/AuthContext";

const Profile = () => {
  const { currentUser, logout } = useAuth();

  return (
    <main className={`w-screen h-screen flex justify-center items-center relative`}>
    </main>
  );
};

export default Profile;